import { Component, Input, OnInit } from '@angular/core';
import { JobType } from 'app/modules/domain/enums/jobType';
import * as _ from 'lodash';
import * as moment from 'moment';
import { isNullOrUndefined } from 'util';

import { Coords } from '../../../../../domain/models/coords';
import { RouteDetailService } from '../../../../services/route-detail.service';
import { RouteDetailViewModel } from '../../../../viewModels/route-detail-viewmodel';

@Component({
  selector: 'app-route-info-item',
  templateUrl: './route-info-item.component.html',
  styleUrls: ['./route-info-item.component.scss']
})
export class RouteInfoItemComponent implements OnInit {
  @Input() routeDetail: RouteDetailViewModel;
  @Input() routeLength: number;
  @Input() hasProject: boolean;

  waypoints: string[];
  routeCost: string;
  days: string[];
  minimized: boolean;
  calculateBudgetSpectrogram: boolean;
  calculateSpectrogram: boolean;
  branchingAnalyse: boolean;
  lineGraph: boolean;
  constructor(private routeDetailService: RouteDetailService) { }

  ngOnInit() {
    this.waypoints = [];
    this.minimized = true;
    this.getRouteCost();
    this.days = this.parseDays();
    this.checkJobTypes();
  }

  getDayName(date: Date): string {
    return moment(date).format('dddd').toUpperCase();
  }

  getHasProject(): boolean {
    return this.hasProject;
  }

  private parseDays(): string[] {
    let days: string[] = [];
    _.each(this.routeDetail.days, (day) => {
      switch (day) {
        case 0:
          days.push('SUNDAY');
          break;
        case 1:
          days.push('MONDAY');
          break;
        case 2:
          days.push('TUESDAY');
          break;
        case 3:
          days.push('WEDNESDAY');
          break;
        case 4:
          days.push('THURSDAY');
          break;
        case 5:
          days.push('FRIDAY');
          break;
        case 6:
          days.push('SATURDAY');
          break;
      }
    });
    return days;
  }

  public toggleWaypoints(): void {
    this.minimized = !this.minimized;
    if (!this.minimized && this.waypoints.length === 0) {
      let waypoints = this.routeDetailService.getCachedWaypoints(this.routeDetail.id);
      if (waypoints !== undefined) {
        this.waypoints = waypoints;
      } else {
        this.geocodeWaypoints(0);
      }
    }
  }

  private geocodeWaypoints(index: number): void {
    if (this.routeDetail.wayPoints.length > index) {
      this.doReverseGeocode(this.routeDetail.wayPoints[index], index);
    } else if (index === this.routeDetail.wayPoints.length) {
      this.routeDetailService.cacheWaypoints(this.waypoints, this.routeDetail.id);
    }
  }

  private doReverseGeocode(wp: Coords, index: number): void {
    setTimeout(() => {
      this.routeDetailService.reverseGeocode(wp)
        .then((result) => {
          if (result[0]) {
            this.waypoints.push(result[0].formatted_address);
          } else {
            this.waypoints.push('Address not found.');
          }
          index++;
          this.geocodeWaypoints(index);
        });
    }, 500);
  }

  private getRouteCost(): void {
    this.routeCost = !isNullOrUndefined(this.routeDetail.cost) ? this.routeDetail.cost.toString() : '';
  }
  private checkJobTypes() {
    this.calculateBudgetSpectrogram = (this.routeDetail.jobType & JobType.BudgetSpectrogram) === JobType.BudgetSpectrogram;
    this.lineGraph = true;
    this.calculateSpectrogram = (this.routeDetail.jobType & JobType.Spectrogram) === JobType.Spectrogram;
    this.branchingAnalyse = (this.routeDetail.jobType & JobType.BranchingAnalyse) === JobType.BranchingAnalyse;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/components/route-info/components/route-info-item/route-info-item.component.ts